/* eslint-disable no-use-before-define */
import React from 'react'
import { ajax, arrayFrom } from '../../twd'

var lastAjaxAbort
export default ({cusip}) => {

    const [issueData, setIssueData] = React.useState({})
    const [askRows, setAskRows] = React.useState([])
    const [bidRows, setBidRows] = React.useState([])

    React.useEffect(() => {
    (async () => {
        setIssueData((await getIssueData(cusip)) || {})

        let {asks, bids} = await getBook(cusip)
        setAskRows(asks)
        setBidRows(bids)
    })()

    return () => {
            if (lastAjaxAbort) lastAjaxAbort()
        }

    }, [cusip])

    return { issueData, askRows, bidRows }
}

const getBook = async (cusip) => {
    try {
        if (lastAjaxAbort) lastAjaxAbort()

        let {data, abort} = await ajax({
            url: '/esb/portfolio/offerbook',
            method: 'POST',
            params: { cusip }
        })

        lastAjaxAbort = abort
        let book = (await data) || {}
        lastAjaxAbort = null

        return {
            asks: arrayFrom(book.askRows).map(r => ({cusip, ...r})),
            bids: arrayFrom(book.bidRows).map(r => ({cusip, ...r})),
        }
    } catch(e) {
        return {
            asks: [],
            bids: [],
        }
    }
}

const getIssueData = async (cusip) => {
    try {
        if (lastAjaxAbort) lastAjaxAbort()

        let {data, abort} = await ajax({
            url: '/esb/portfolio/cusip/issuedata',
            method: 'GET',
            params: { cusip }
        })

        lastAjaxAbort = abort
        let info = ((await data) || {}).IssueData || {}
        lastAjaxAbort = null

        return {
            holdCusip: info.cusip,
            holdIssue: info.issueDisplay,
            holdInvType: info.type,
            maturity: info.maturity,
            moodyRating: info.moodyRating,
            spRating: info.spRating,
            holdCoupon: info.coupon,
            firstCouponDate: info.firstCoupon,
            nextCouponDate: info.nextCoupon,
            datedDate: info.dated,
            holdWarningText: info.warningText,
            floaterInd: info.floaterInd,
        }
    } catch(e) {
        return null
    }
}






// WEBPACK FOOTER //
// ./src/offerings/depth-of-market/use-depth-of-market.js